import React from "react"
import { connect } from "react-redux"
import { authorize } from "../decorators/authorize"
import requireStore from "../decorators/requireStore"
import { employeesPage } from "../config/routesInfo"
import {
  createEmployee,
  deleteEmployee,
  editEmployee,
  refresh,
} from "../ducks/employees"
import EmployeesHolder from "../components/EmployeesHolder"
import { Button, Grid, Icon } from "semantic-ui-react"
import EmployeeCard from "../components/EmployeeCard"
import Info from "../components/Info"
import bind from "bind-decorator"
import { withRouter } from "react-router-dom"
import { withTranslation } from "react-i18next"
@authorize(...employeesPage.permissions)
@requireStore()
@withRouter
@withTranslation()
@connect(
  (state) => ({
    currentStoreId: state.profile.currentStore.id,
    isLoading: state.employees.isLoading,
    employees: state.employees.employees,
    loadingEmployeeIds: state.employees.loadingEmployeeIds,
    storeOptions: state.profile.stores.map((s) => ({
      value: s.id,
      text: s.name,
      name: s.name,
      key: s.id,
      address: s.address,
    })),
  }),
  (dispatch) => ({
    refresh: () => dispatch(refresh()),
    deleteEmployee: (...data) => dispatch(deleteEmployee(...data)),
    editEmployee: (...data) => dispatch(editEmployee(...data)),
    createEmployee: (...data) => dispatch(createEmployee(...data)),
  }),
)
export default class SalesPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      creating: false,
      modal: true,
      adding: false,
    }
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillReceiveProps(newProps) {
    const { currentStoreId, refresh } = this.props
    if (newProps.currentStoreId !== currentStoreId) {
      refresh()
    }
  }

  componentDidMount() {
    this.props.refresh()
  }

  @bind
  onStartCreating() {
    this.setState({
      creating: true,
    })
  }

  @bind
  cancelCreating() {
    this.setState({
      creating: false,
    })
  }

  @bind
  handleModal() {
    this.setState({
      modal: false,
    })
  }

  @bind
  showAdding() {
    this.setState({
      adding: true,
    })
  }

  render() {
    const { t } = this.props
    const { creating } = this.state
    const {
      employees,
      isLoading,
      loadingEmployeeIds,
      createEmployee,
      editEmployee,
      deleteEmployee,
      refresh,
      storeOptions,
    } = this.props
    return (
      <div className="employees-page">
        <h2>
          {t("employeesPage")}
          <Info
            text={
              <div>
                <p>{t("In this section you can")}</p>
                <ul>
                  <li>{t("Add new employees to stores")}</li>
                  <li>{t("Remove employees from stores")}</li>
                  <li>{t("Edit employee access levels")}</li>
                </ul>
                <p>
                  {t(
                    "Please note that to add an employee, his / her IIN and cell phone number are required",
                  )}
                </p>
              </div>
            }
          />
          <Button basic icon disabled={isLoading} onClick={refresh}>
            <Icon name="refresh" link loading={isLoading} />
          </Button>
          <Button color="green" onClick={this.onStartCreating}>
            {t("add")}
          </Button>
        </h2>
        {creating && (
          <Grid>
            <Grid.Row centered>
              <Grid.Column computer={8} tablet={16}>
                <EmployeeCard
                  storeOptions={storeOptions}
                  createEmployee={createEmployee}
                  cancelCreating={this.cancelCreating}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        )}
        <EmployeesHolder
          employees={employees}
          loadingEmployeeIds={loadingEmployeeIds}
          deleteEmployee={deleteEmployee}
          editEmployee={editEmployee}
          createEmployee={createEmployee}
          storeOptions={storeOptions}
        />
      </div>
    )
  }
}
